import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function Drawer({ isOpen, onClose, activePage }) {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  // Handle body overflow when drawer is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Cleanup function to reset overflow when component unmounts
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleLogout = async () => {
    try {
      await logout();
      onClose();
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <>
      {/* Drawer */}
      <aside
        className={`mdc-drawer mdc-drawer--modal ${isOpen ? 'mdc-drawer--open' : 'mdc-drawer--closed'}`}
      >
        <div className="mdc-drawer__content">
          <nav className="mdc-list">
            <Link
              to="/"
              className={`mdc-list-item ${activePage === 'mainContent' ? 'mdc-list-item--activated' : ''}`}
              onClick={onClose}
              aria-current={activePage === 'mainContent' ? 'page' : undefined}
            >
              Home
            </Link>
            <Link
              to="/voters"
              className={`mdc-list-item ${activePage === 'voterContent' ? 'mdc-list-item--activated' : ''}`}
              onClick={onClose}
              aria-current={activePage === 'voterContent' ? 'page' : undefined}
            >
              Voters
            </Link>
            <Link
              to="/postcards"
              className={`mdc-list-item ${activePage === 'postcardsContent' ? 'mdc-list-item--activated' : ''}`}
              onClick={onClose}
              aria-current={activePage === 'postcardsContent' ? 'page' : undefined}
            >
              Postcards
            </Link>
            <Link
              to="/about"
              className={`mdc-list-item ${activePage === 'aboutContent' ? 'mdc-list-item--activated' : ''}`}
              onClick={onClose}
              aria-current={activePage === 'aboutContent' ? 'page' : undefined}
            >
              About
            </Link>
            <Link
              to="/mailing-lists"
              className={`mdc-list-item ${activePage === 'mailingListsContent' ? 'mdc-list-item--activated' : ''}`}
              onClick={onClose}
              aria-current={activePage === 'mailingListsContent' ? 'page' : undefined}
            >
              Mailing Lists
            </Link>
            {currentUser ? (
              <>
                <Link
                  to="/profile"
                  className={`mdc-list-item ${activePage === 'profileContent' ? 'mdc-list-item--activated' : ''}`}
                  onClick={onClose}
                  aria-current={activePage === 'profileContent' ? 'page' : undefined}
                >
                  Profile
                </Link>
                <button
                  type="button"
                  className="mdc-list-item"
                  onClick={handleLogout}
                  style={{ width: 'calc(100% - 32px)', textAlign: 'left', background: 'transparent', border: 'none', cursor: 'pointer', fontFamily: 'inherit' }}
                >
                  Logout
                </button>
              </>
            ) : (
              <Link
                to="/login"
                className={`mdc-list-item ${activePage === 'loginContent' ? 'mdc-list-item--activated' : ''}`}
                onClick={onClose}
                aria-current={activePage === 'loginContent' ? 'page' : undefined}
              >
                Login
              </Link>
            )}
            <a
              href="https://app.doornoc.com"
              target="_blank"
              rel="noopener noreferrer"
              className="mdc-list-item drawer-switch-link"
              onClick={onClose}
            >
              Switch to DoorNoc ↗
            </a>
          </nav>
        </div>
      </aside>

      {/* Scrim/Overlay - Always rendered but visibility controlled by CSS */}
      <div
        className={`mdc-drawer-scrim ${isOpen ? 'visible' : ''}`}
        onClick={onClose}
      />
    </>
  );
}

export default Drawer;
